import { useParams } from 'react-router-dom'
import EditQuestionSetForm from './EditQuestionSetForm'

import { useGetQuestionSetsQuery } from './questionSetsApiSlice'

import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
import { useGetGroupsQuery } from '../groups/groupsApiSlice'
import GenerateQuestionSetToUsersForm from './GenerateQuestionSetToUsersForm'
const GenerateQuestionSetToUsers = () => {
    useTitle('geshtop-Exercise: Edit QuestionSet')

    const { questionSetId } = useParams()


    const { questionSet } = useGetQuestionSetsQuery("questionSetsList", {
        selectFromResult: ({ data }) => ({
            questionSet: data?.entities[questionSetId]
        }),
    })

    const { groups } = useGetGroupsQuery("groupsList", {
        selectFromResult: ({ data }) => ({
            groups: data?.ids.map(id => data?.entities[id])
        }),
    })


    if (!questionSet || !groups) return <PulseLoader color={"#FFF"} />



    const content =
    <>
    <GenerateQuestionSetToUsersForm questionSet={questionSet} groups={groups} />  
       
    </>

    return content
}
export default GenerateQuestionSetToUsers